import { render, staticRenderFns } from "./CalculatedIncomeTax.vue?vue&type=template&id=c7357ec2&scoped=true&"
import script from "./CalculatedIncomeTax.vue?vue&type=script&lang=js&"
export * from "./CalculatedIncomeTax.vue?vue&type=script&lang=js&"
import style0 from "./CalculatedIncomeTax.vue?vue&type=style&index=0&id=c7357ec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7357ec2",
  null
  
)

export default component.exports